/* eslint-disable react-refresh/only-export-components */

// DevStatusBadge — outline pill with a colored status dot, ported from dev.
// Single render path used everywhere (agent cards + header).

import { Badge } from '@/shared/ui/badge';
import { cn } from '@/shared/lib/cn';

export type DevStatus = 'live' | 'experimental' | 'development' | 'planned';

const borderTextStyles: Record<DevStatus, string> = {
  live: 'border-status-success text-status-success',
  experimental: 'border-status-warning text-status-warning',
  development: 'border-status-warning text-status-warning',
  planned: 'border-border text-muted-foreground',
};

const dotStyles: Record<DevStatus, string> = {
  live: 'bg-status-success',
  experimental: 'bg-status-warning',
  development: 'bg-status-warning',
  planned: 'bg-muted-foreground',
};

export function devStatusColor(status: DevStatus | null | undefined): string {
  if (!status) return 'var(--color-muted-foreground)';
  if (status === 'live') return 'var(--color-status-success)';
  if (status === 'experimental' || status === 'development') return 'var(--color-status-warning)';
  return 'var(--color-muted-foreground)';
}

type Props = {
  status: DevStatus;
};

export function DevStatusBadge({ status }: Props) {
  return (
    <span className="inline-flex shrink-0">
      <Badge variant="outline" className={cn('gap-1.5 whitespace-nowrap', borderTextStyles[status])}>
        <span className={cn('size-1.5 shrink-0 rounded-full', dotStyles[status])} />
        {status}
      </Badge>
    </span>
  );
}
